export default __webpack_public_path__ + "static/media/brand_reference.4b58a93a.png";